export default __webpack_public_path__ + "static/hooligan-development-privacy-policy-ec24ae03fe944322d2f4962e7c93d651.pdf";